import { default as _91_46_46_46catchAll_936FA629IU4uMeta } from "/app/pages/[...catchAll].vue?macro=true";
import { default as indexnxoTsLxaQGMeta } from "/app/pages/access-management/applications/[application_id]/api-keys/index.vue?macro=true";
import { default as index350K19YQwiMeta } from "/app/pages/access-management/applications/[application_id]/index.vue?macro=true";
import { default as indexOeZz2JWlMEMeta } from "/app/pages/access-management/applications/index.vue?macro=true";
import { default as indexuMZjITmQckMeta } from "/app/pages/access-management/scopes/[scope_id]/index.vue?macro=true";
import { default as indexXwhF8WbpPmMeta } from "/app/pages/access-management/scopes/index.vue?macro=true";
import { default as index7hsnlHGkXSMeta } from "/app/pages/access-management/users/[user_id]/index.vue?macro=true";
import { default as indexQA6PnWuvzuMeta } from "/app/pages/access-management/users/index.vue?macro=true";
import { default as indexgnxjRs9LIzMeta } from "/app/pages/conversation/[user_id]/[chat_id]/index.vue?macro=true";
import { default as indexiGI2m8EmNfMeta } from "/app/pages/conversation/[user_id]/index.vue?macro=true";
import { default as indexhRA2a8PBPXMeta } from "/app/pages/conversation/index.vue?macro=true";
import { default as indexhg2nWJrbRRMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as indexQr1a1bfvsXMeta } from "/app/pages/knowledge/[id]/index.vue?macro=true";
import { default as indexNu882nngOuMeta } from "/app/pages/knowledge/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as indexwsRUdgFOZYMeta } from "/app/pages/preset/[id]/index.vue?macro=true";
import { default as indexNZsKVkRmyfMeta } from "/app/pages/preset/index.vue?macro=true";
import { default as indexRwdg4wLVEfMeta } from "/app/pages/prompt-library/index.vue?macro=true";
import { default as indexpJD7fWWogNMeta } from "/app/pages/quota/[quota_id]/index.vue?macro=true";
import { default as indexAThPK3xkz3Meta } from "/app/pages/quota/index.vue?macro=true";
import { default as indexGHSxdaQaZSMeta } from "/app/pages/report/token-usage/[user_id]/[id]/index.vue?macro=true";
import { default as indexfei2TvSJv2Meta } from "/app/pages/report/token-usage/[user_id]/index.vue?macro=true";
import { default as indexdOnlJmWPxOMeta } from "/app/pages/report/token-usage/index.vue?macro=true";
import { default as indexn00TLIBUb5Meta } from "/app/pages/workflow/[id]/index.vue?macro=true";
import { default as indexUkDK8jUPa4Meta } from "/app/pages/workflow/index.vue?macro=true";
export default [
  {
    name: "catchAll",
    path: "/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_936FA629IU4uMeta || {},
    component: () => import("/app/pages/[...catchAll].vue")
  },
  {
    name: "access-management-applications-application_id-api-keys",
    path: "/access-management/applications/:application_id()/api-keys",
    meta: indexnxoTsLxaQGMeta || {},
    component: () => import("/app/pages/access-management/applications/[application_id]/api-keys/index.vue")
  },
  {
    name: "access-management-applications-application_id",
    path: "/access-management/applications/:application_id()",
    meta: index350K19YQwiMeta || {},
    component: () => import("/app/pages/access-management/applications/[application_id]/index.vue")
  },
  {
    name: "access-management-applications",
    path: "/access-management/applications",
    meta: indexOeZz2JWlMEMeta || {},
    component: () => import("/app/pages/access-management/applications/index.vue")
  },
  {
    name: "access-management-scopes-scope_id",
    path: "/access-management/scopes/:scope_id()",
    meta: indexuMZjITmQckMeta || {},
    component: () => import("/app/pages/access-management/scopes/[scope_id]/index.vue")
  },
  {
    name: "access-management-scopes",
    path: "/access-management/scopes",
    meta: indexXwhF8WbpPmMeta || {},
    component: () => import("/app/pages/access-management/scopes/index.vue")
  },
  {
    name: "access-management-users-user_id",
    path: "/access-management/users/:user_id()",
    meta: index7hsnlHGkXSMeta || {},
    component: () => import("/app/pages/access-management/users/[user_id]/index.vue")
  },
  {
    name: "access-management-users",
    path: "/access-management/users",
    meta: indexQA6PnWuvzuMeta || {},
    component: () => import("/app/pages/access-management/users/index.vue")
  },
  {
    name: "conversation-user_id-chat_id",
    path: "/conversation/:user_id()/:chat_id()",
    meta: indexgnxjRs9LIzMeta || {},
    component: () => import("/app/pages/conversation/[user_id]/[chat_id]/index.vue")
  },
  {
    name: "conversation-user_id",
    path: "/conversation/:user_id()",
    meta: indexiGI2m8EmNfMeta || {},
    component: () => import("/app/pages/conversation/[user_id]/index.vue")
  },
  {
    name: "conversation",
    path: "/conversation",
    meta: indexhRA2a8PBPXMeta || {},
    component: () => import("/app/pages/conversation/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "knowledge-id",
    path: "/knowledge/:id()",
    meta: indexQr1a1bfvsXMeta || {},
    component: () => import("/app/pages/knowledge/[id]/index.vue")
  },
  {
    name: "knowledge",
    path: "/knowledge",
    meta: indexNu882nngOuMeta || {},
    component: () => import("/app/pages/knowledge/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginhHM0vSTW5jMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "preset-id",
    path: "/preset/:id()",
    meta: indexwsRUdgFOZYMeta || {},
    component: () => import("/app/pages/preset/[id]/index.vue")
  },
  {
    name: "preset",
    path: "/preset",
    meta: indexNZsKVkRmyfMeta || {},
    component: () => import("/app/pages/preset/index.vue")
  },
  {
    name: "prompt-library",
    path: "/prompt-library",
    meta: indexRwdg4wLVEfMeta || {},
    component: () => import("/app/pages/prompt-library/index.vue")
  },
  {
    name: "quota-quota_id",
    path: "/quota/:quota_id()",
    meta: indexpJD7fWWogNMeta || {},
    component: () => import("/app/pages/quota/[quota_id]/index.vue")
  },
  {
    name: "quota",
    path: "/quota",
    meta: indexAThPK3xkz3Meta || {},
    component: () => import("/app/pages/quota/index.vue")
  },
  {
    name: "report-token-usage-user_id-id",
    path: "/report/token-usage/:user_id()/:id()",
    meta: indexGHSxdaQaZSMeta || {},
    component: () => import("/app/pages/report/token-usage/[user_id]/[id]/index.vue")
  },
  {
    name: "report-token-usage-user_id",
    path: "/report/token-usage/:user_id()",
    meta: indexfei2TvSJv2Meta || {},
    component: () => import("/app/pages/report/token-usage/[user_id]/index.vue")
  },
  {
    name: "report-token-usage",
    path: "/report/token-usage",
    meta: indexdOnlJmWPxOMeta || {},
    component: () => import("/app/pages/report/token-usage/index.vue")
  },
  {
    name: "workflow-id",
    path: "/workflow/:id()",
    meta: indexn00TLIBUb5Meta || {},
    component: () => import("/app/pages/workflow/[id]/index.vue")
  },
  {
    name: "workflow",
    path: "/workflow",
    meta: indexUkDK8jUPa4Meta || {},
    component: () => import("/app/pages/workflow/index.vue")
  }
]